import { storage } from './storage';

export type Theme = 'auto' | 'light' | 'dark';

export function applyTheme(t: Theme): void {
  const root = document.documentElement;
  if (t === 'auto') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', t);
  storage.set('pace.theme', t);
}

export const savedTheme = (): Theme => (storage.get('pace.theme') as Theme | null) ?? 'auto';
